// extracted by mini-css-extract-plugin
export var about = "index-module--about--1C_IR";
export var textContent = "index-module--textContent--rk9zo";
export var techStack = "index-module--techStack--87h1K";